var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcManageContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 4.5,
    fill: "white",
    stroke: "#B5B5B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 27.5C14.2152 27.5 11.5445 26.3938 9.57538 24.4246C7.60625 22.4555 6.5 19.7848 6.5 17C6.5 14.2152 7.60625 11.5445 9.57538 9.57538C11.5445 7.60625 14.2152 6.5 17 6.5C22.7983 6.5 27.5 10.679 27.5 15.8333C27.5 17.07 26.947 18.2577 25.9623 19.1327C24.9777 20.0077 23.6418 20.5 22.25 20.5H19.3333C18.8128 20.4916 18.3045 20.6575 17.8891 20.9713C17.4738 21.2851 17.1753 21.7288 17.0412 22.2318C16.9071 22.7348 16.945 23.2682 17.1489 23.7472C17.3529 24.2261 17.7111 24.6231 18.1667 24.875C18.3996 25.0899 18.5594 25.3725 18.6235 25.6829C18.6876 25.9933 18.6528 26.316 18.5241 26.6056C18.3954 26.8953 18.1791 27.1373 17.9058 27.2977C17.6324 27.4581 17.3156 27.5289 17 27.5Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.2499C11.75 15.5593 11.8729 15.8561 12.0917 16.0749C12.3105 16.2937 12.6072 16.4166 12.9167 16.4166C13.2261 16.4166 13.5228 16.2937 13.7416 16.0749C13.9604 15.8561 14.0833 15.5593 14.0833 15.2499C14.0833 14.9405 13.9604 14.6438 13.7416 14.425C13.5228 14.2062 13.2261 14.0833 12.9167 14.0833C12.6072 14.0833 12.3105 14.2062 12.0917 14.425C11.8729 14.6438 11.75 14.9405 11.75 15.2499Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4165 11.7499C16.4165 12.0593 16.5394 12.3561 16.7582 12.5749C16.977 12.7937 17.2738 12.9166 17.5832 12.9166C17.8926 12.9166 18.1893 12.7937 18.4081 12.5749C18.6269 12.3561 18.7498 12.0593 18.7498 11.7499C18.7498 11.4405 18.6269 11.1438 18.4081 10.925C18.1893 10.7062 17.8926 10.5833 17.5832 10.5833C17.2738 10.5833 16.977 10.7062 16.7582 10.925C16.5394 11.1438 16.4165 11.4405 16.4165 11.7499Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0835 15.2499C21.0835 15.5593 21.2064 15.8561 21.4252 16.0749C21.644 16.2937 21.9407 16.4166 22.2502 16.4166C22.5596 16.4166 22.8563 16.2937 23.0751 16.0749C23.2939 15.8561 23.4168 15.5593 23.4168 15.2499C23.4168 14.9405 23.2939 14.6438 23.0751 14.425C22.8563 14.2062 22.5596 14.0833 22.2502 14.0833C21.9407 14.0833 21.644 14.2062 21.4252 14.425C21.2064 14.6438 21.0835 14.9405 21.0835 15.2499Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcManageContent);
export default __webpack_public_path__ + "static/media/ic-manageContent.9ad7d9ffefe6bcb7c41a59bc77991be4.svg";
export { ForwardRef as ReactComponent };